import { TokenProvider, TokenResponse } from '@fluidx/office-fluid-types';
import { logUsage } from 'owa-analytics';
import { timestamp } from 'owa-datetime';
import { format } from 'owa-localize';
import { getAccessTokenforResourceAsLazy, AccessTokenResponse } from 'owa-tokenprovider';
import { parse as parseUrl } from 'url';

export class FluidTokenProvider implements TokenProvider {
    get TokenProvider() {
        return this;
    }

    public async getToken(scopes: string[]): Promise<TokenResponse> {
        // Per conversations with Attachments, the tokens we get for resources should have all permissions.
        // Since this will only be called with one domain (and potentially multiple scopes), we should just request the first scope.
        // We may want to revisit this in the future.
        if (scopes && scopes.length > 0) {
            let resourceUrl = scopes[0];
            const parsedUrl = parseUrl(resourceUrl);

            // owh assumed a graph resource if no host is provided. This is going to be changed and a graph resourceUrl
            // will be provided eventually, but in the mean time we use this to follow that assumption.
            if (!parsedUrl.host) {
                resourceUrl = 'https://graph.microsoft.com/';
            } else {
                resourceUrl = format('{0}//{1}/', parsedUrl.protocol, parsedUrl.hostname);
            }

            const startTime = timestamp();
            const [token, tokenPromise] = getAccessTokenforResourceAsLazy(resourceUrl);

            // If there is a token available, wrap it in a promise and return it
            if (token) {
                return { token: token as string, fromCache: true };
            }

            const asyncToken = (await tokenPromise) as string;
            logAuthTokenFetchTime(token, tokenPromise, resourceUrl, startTime);

            // otherwise return the promise we are waiting on
            return { token: asyncToken, fromCache: false };
        } else {
            return Promise.resolve(undefined);
        }
    }
}

async function logAuthTokenFetchTime(
    token: string | AccessTokenResponse,
    tokenPromise: Promise<string | AccessTokenResponse>,
    resourceUrl: string,
    startTime: number
) {
    if (token) {
        logUsage(
            'FluidFetchToken',
            { fromCache: true, resourceUrl: resourceUrl },
            { isCore: true }
        );
    } else {
        (await tokenPromise) as string;
        const duration = timestamp() - startTime;
        logUsage(
            'FluidFetchToken',
            { fromCache: false, resourceUrl: resourceUrl, duration: duration?.toString() },
            { isCore: true }
        );
    }
}
